import './HomeScreen.css';
import LoveOfDogs from './LoveOfDogs';
import WhatsSP from './WhatsSP';
import ScrollingText from './ScrollingText';
import TestimonialCarousel from './TestimonialCarousel';
import FollowInstaText from './FollowInstaText';
import InstagramPost from './InstagramPost';
import EventView from './EventView';
import SponsersView from './SponsersView';
import Footer from '../../components/Footer';
export default function HomeScreen() {
  return <div className="home-page"><LoveOfDogs/><main><WhatsSP/><ScrollingText/><TestimonialCarousel/><FollowInstaText/><InstagramPost/><EventView/><SponsersView/></main><Footer/></div>;
}
